import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { useEffect, useState } from "react";
import { subscribeApiLoading } from "@/lib/api-loading-bus";

/**
 * Full-viewport dimmed overlay while any `apiFetch` request is in progress.
 */
export function ApiLoadingOverlay() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    return subscribeApiLoading((n) => {
      setOpen(n > 0);
    });
  }, []);

  return (
    <Backdrop
      sx={(theme) => ({
        color: '#0d47a1',
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        zIndex: theme.zIndex.modal + 1,
      })}
      open={open}
    >
      <CircularProgress color="inherit" size={48} />
    </Backdrop>
  );
}
